import { useContext } from "react";
import { ConfiguratorContext, initialContext } from "../context";

/**
 * Calcula el precio total sobre un snapshot de estado cualquiera.
 * Es una función pura para poder evaluarla también fuera del render
 * (por ejemplo al validar que una simulación siga vigente).
 */
export const computeFinancedTotal = (state, simulatingCredit = false) => {
    const version = state.selectedVersion;
    const accessoriesPrice = state.summary.accessories;
    const ignoreAccessories = state.accessories.ignore.value;
    const ignoreFinanciado = state.financiado.ignore.value;
    const isSmartBuy = state.financiado.smart_buy;
    const prepaidMaintenancePlan = state.selectedPrepaidMaintenancePlan;
    const selectedPaymentOption = state.selectedPaymentOption;
    const isCash = selectedPaymentOption === 1; // 1 = Contado

    if (version) {
        // Arrancamos con el precio de lista
        let price = parseFloat(version.list_price);

        // Restamos bono marca si hay
        if (version.brand_bonus) {
            price = price - parseFloat(version.brand_bonus);
        }

        // Si tiene bono financiado y estamos financiando, lo restamos
        if (version.financing_bonus && (!ignoreFinanciado || simulatingCredit)) {
            price = price - parseFloat(version.financing_bonus);
        }

        // Si tiene bono plan renueve, está activada la opción y estamos financiando, lo restamos
        if (version.smart_buy_bonus && isSmartBuy && (!ignoreFinanciado || simulatingCredit)) {
            price = price - parseFloat(version.smart_buy_bonus);
        }

        // Si tiene accesorios los sumamos
        if (!ignoreAccessories) {
            price = price + parseFloat(accessoriesPrice);
        }

        if (prepaidMaintenancePlan && !isCash) {
            price = price + parseFloat(prepaidMaintenancePlan.price);
        }

        return price;
    }

    return false;
};

/**
 * Hook para cálculo y manejo de precios del configurador
 * Gestiona precios finales, bonos, descuentos y financiamiento
 */
const usePriceData = () => {
    const [state, setState] = useContext(ConfiguratorContext);

    // Obtiene el precio total considerando bonos, accesorios y financiamiento
    const getFinancedTotal = (simulatingCredit = false) => computeFinancedTotal(state, simulatingCredit);

    // Obtiene el precio solo con bonos aplicados (sin accesorios)
    const getPriceWithBonusOnly = () => {
        const version = state.selectedVersion;
        const ignoreFinanciado = state.financiado.ignore.value;
        const isSmartBuy = state.financiado.smart_buy;

        let price = parseFloat(version.list_price);

        if (version.brand_bonus) {
            price = price - parseFloat(version.brand_bonus);
        }

        if (version.financing_bonus && !ignoreFinanciado) {
            price = price - parseFloat(version.financing_bonus);
        }

        if (version.smart_buy_bonus && isSmartBuy && !ignoreFinanciado) {
            price = price - parseFloat(version.smart_buy_bonus);
        }

        return price !== parseFloat(version.list_price) ? price : null;
    };

    // Obtiene el precio final calculado
    const getFinalPrice = () => {
        let price = getFinancedTotal();

        if (price) {
            // const ignoreFinanciado = state.financiado.ignore.value;

            // // aca, si ya simulo, piso el precio con el valor que vino de credito
            // if (!ignoreFinanciado && state.financiado.credit_total_cost) {
            //     price = parseFloat(state.financiado.credit_total_cost);

            //     // si fue un r9 sumo la cuota final
            //     if (state.financiado.smart_buy && state.financiado.future_value_guaranteed) {
            //         price = price + parseFloat(state.financiado.future_value_guaranteed);
            //     }

            //     price = price + parseFloat(state.financiado.downpayment_amount);
            // }

            return price;
        }

        return false;
    };

    return {
        getFinalPrice,
        getFinancedTotal,
        getPriceWithBonusOnly,
    };
};

export default usePriceData;
